// extracted by mini-css-extract-plugin
export default {"switcherGroup":"OfflineModeButton__switcherGroup--2llbv","switcher":"OfflineModeButton__switcher--laxRN"};